import React from 'react'
import {
  Radio as ChakraRadio,
  RadioProps,
  RadioGroup as ChakraRadioGroup,
  RadioGroupProps,
} from '@chakra-ui/react'
import { injectTheme } from '@hub/design-system-base'
import { radioTheme } from './theme'

injectTheme('Radio', radioTheme)

export const Radio: React.FC<
  React.PropsWithChildren<
    Pick<
      RadioProps,
      | 'as'
      | 'sx'
      | 'children'
      | 'spacing'
      | 'id'
      | 'name'
      | 'value'
      | 'isChecked'
      | 'defaultChecked'
      | 'isDisabled'
      | 'isReadOnly'
      | 'isInvalid'
      | 'isRequired'
      | 'onChange'
      | 'size'
    >
  >
> = props => <ChakraRadio {...props} />

export const RadioGroup: React.FC<
  React.PropsWithChildren<
    Pick<
      RadioGroupProps,
      | 'as'
      | 'sx'
      | 'children'
      | 'value'
      | 'defaultValue'
      | 'onChange'
      | 'name'
      | 'isNative'
    >
  >
> = props => <ChakraRadioGroup {...props} />
